exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spoiler-warning[data-v-d735ead2]{color:red;font-weight:700}.mystery[data-v-d735ead2]{font-weight:700}", ""]);

// exports
